import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ControllerContext from '../../../RoomControllerSocketContext';
import callApi from '../libs/callApi';
import DotSpinLoader from '../../Loader/dotSpinLoader';

const DesktopFooter = () =>
{
	const history = useHistory();
	const { pluginSocket } = useContext(ControllerContext);
	const [ devicesData, setDevicesData ] = useState('');
	const [ roomId, setRoomId ] = useState('');
	const [ isLoading, setIsLoading ] = useState(false);
	const [ version, serVersion ] = useState('');

	useEffect(() =>
	{
		async function getRoomData()
		{
			const devicesIdData = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');
			const roomIdData = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'roomId');
			const versionData = await window?.electron?.ipcRenderer?.invoke('getAppVersion');

			if (devicesIdData?.controllerUniqueId)
			{
				setDevicesData(devicesIdData);
			}
			if (roomIdData)
			{
				setRoomId(roomIdData);
			}
			if (versionData)
			{
				serVersion(versionData);
			}
		}
		getRoomData();
	}, []);

	const handleExit = () =>
	{
		window?.electron?.ipcRenderer?.sendMessage('quitApp');
		// history.push('/desktop_room');
	};

	async function deleteData()
	{
		const unpairStatus = await window?.electron?.ipcRenderer?.invoke('unpair');

		console.log('unpair status===', unpairStatus);

		if (unpairStatus)
		{
			pluginSocket.emit('unpair');
			history.push('/');
		}
	}

	const handleUnpair = async () =>
	{
		console.log('roomId===', roomId);

		if (roomId)
		{
			setIsLoading(true);
			const body = {
				'roomId'       : roomId,
				'desktopId'    : devicesData?.desktopUniqueId,
				'controllerId' : devicesData?.controllerUniqueId,
				'deviceType'   : 'desktop',
				'activeStatus' : false
			};

			const dataforRoomPlugin = JSON.stringify({
				'path'    : '/plugins/updateactivestatus',
				'method'  : 'PUT',
				'apiBody' : body
			});

			console.log('bodyyy===', body);
			console.log('dataforRoomPlugin===', dataforRoomPlugin);

			try
			{
				const RoomResponse = await callApi(dataforRoomPlugin);

				console.log('????????????????????====', RoomResponse);
				if (RoomResponse?.status)
				{
					deleteData();
				}
			}
			catch (error)
			{
				console.log('error in unpairing===', error);
			}
			setIsLoading(false);
		}
		else
		{
			deleteData();
		}
	};

	return (
		<div className='flexRow pdngTSM pdngRMD footerHeight'>
			<div className='flexMinWidthRow mrgnLMD'>
				<span className='versionPosition wTxt'>
					v{version}
				</span>
			</div>
			{devicesData?.controllerUniqueId && <span className='exitbtnPosition pointer mrgnRMD' onClick={handleUnpair}>
				Unpair
			</span>}
			<span className='exitbtnPosition pointer' onClick={handleExit}>
				Exit
			</span>
			{isLoading && <DotSpinLoader/>}
		</div>
	);
};

export default DesktopFooter;
